// extracted by mini-css-extract-plugin
export default {"phonesAndTexts":"IDScanner_phonesAndTexts__Pzx-1","phones":"IDScanner_phones__mvHC9","phone":"IDScanner_phone__P2c-s","texts":"IDScanner_texts__r7AvT"};